'use client';

import { useTranslations } from 'next-intl';
import { BackgroundGradient } from '@//components/BackgroundGradient';
import { Heading } from '@//components/Heading';
import { WidgetForm } from '@//components/WidgetForm';
import type { LegacyTrackAssignmentInitiatedEventDataContextPlacement } from '@//data/tracking/legacy-types';
import AssignmentForm from '../AssignmentForm';
import styles from './AssignmentWidgetSlim.module.scss';

const AssignmentWidgetSlimClient: React.FC<{
  marketMetadata: any;
  trackingPlacement: LegacyTrackAssignmentInitiatedEventDataContextPlacement;
}> = ({ marketMetadata, trackingPlacement }) => {
  const t = useTranslations('components.assignmentWidget');

  const useAnimatedGradient = true;

  return (
    <article className={styles.widget}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <Heading level={2} size="2xl">
            {t('heading')}
          </Heading>
          <p className={styles.description}>{t('description')}</p>
        </div>
        <WidgetForm variant="responsive">
          <AssignmentForm
            id="assignment-widget-slim"
            assignmentPagePath={marketMetadata.pageLinks.assignmentPage}
            trackingPlacement={trackingPlacement}
          />
        </WidgetForm>
        {useAnimatedGradient ? (
          <BackgroundGradient />
        ) : (
          <img
            src="/markets/wayke/gradient/large.jpg"
            alt="Backdround gradient"
            className={styles.gradient}
            aria-hidden="true"
            role="presentation"
          />
        )}
      </div>
    </article>
  );
};

export default AssignmentWidgetSlimClient;
